// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"85321090","453":"2623a759","667":"0ee168de","977":"35c25051"}[chunkId] + ".chunk.js";
};